export default "__VITE_ASSET__Dd$XFeab__";